import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconPhone = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6665 15.28V17.28C18.668 17.6554 18.5112 18.0141 18.2345 18.2679C17.9579 18.5217 17.587 18.6471 17.2131 18.6133C15.1617 18.3904 13.1911 17.6894 11.4598 16.5667C9.84902 15.5431 8.48335 14.1774 7.4598 12.5667C6.33312 10.8275 5.63196 8.84731 5.41313 6.78665C5.37945 6.4139 5.50398 6.04415 5.75631 5.76773C6.00864 5.49131 6.36553 5.33367 6.7398 5.33332H8.7398C9.40904 5.32673 9.97946 5.8173 10.0731 6.47998C10.1575 7.12003 10.3141 7.74847 10.5398 8.35332C10.723 8.84057 10.6058 9.38985 10.2398 9.75998L9.39313 10.6067C10.3422 12.2757 11.7241 13.6576 13.3931 14.6067L14.2398 13.76C14.6099 13.394 15.1592 13.2768 15.6465 13.46C16.2513 13.6857 16.8798 13.8422 17.5198 13.9267C18.1902 14.0212 18.6833 14.6032 18.6665 15.28Z"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);
